import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";


function Home() {
    const navigate = useNavigate();
    const [userData, setUserData] = useState({});
      const location = useLocation();
    
      useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const name = searchParams.get("name");
        const application_id = searchParams.get("application_id");
        const token = searchParams.get("token");
        const purpose = searchParams.get("purpose");
        const service_name = searchParams.get("service_name");
        let params = {};
        try {
          params = JSON.parse(searchParams.get("params")).map(param=> {
            const parsedParam = param.split('|');
            const [orgid, _documentTypes] = parsedParam.splice(0, 2);
            const documentTypes = _documentTypes.split(',');
            return {
              orgid,
              documentTypes,
              ...parsedParam.reduce((acc, cv)=> {
                const [key, value] = cv.split(":")
                return {
                  ...acc,
                  [key]: value
                };
              },{})
            }
          });
          console.log("params", params)
        } catch {

        }
        
        if (name && application_id && token) {
          setUserData({
            name: name,
            application_id: application_id,
            token: token,
            purpose,
            service_name,
            params
          });
        } else {
            setUserData(null);
        }
      }, [location.search]);
    
      useEffect(() => {
        if (userData === null) {
            sessionStorage.clear();
            navigate('/error');
        }
        if (userData && userData.name && userData.application_id && userData.token) {
            sessionStorage.setItem("user_data", JSON.stringify(userData));
            navigate('/allow-permission', {state: userData});
        }
      }, [userData, navigate]);

      
    return <>
        Redirecting...
    </>
}


export default Home;